import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from './views/Home.vue';
import SearchVouchersView from './views/SearchVouchersView.vue';
import VoucherView from './views/VoucherView.vue';
import MessageView from './views/MessageView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "./views/About.vue"),
  // },
  {
    path: '/search-vouchers',
    name: 'search-vouchers',
    component: SearchVouchersView,
  },
  {
    path: '/vouchers',
    name: 'vouchers',
    component: VoucherView,
  },
  {
    path: '/creditor-not-found',
    name: 'creditor-not-found',
    props: {
      messages: [
        'Ups, hubo un problema...',
        'El RUT no fue encontrado',
        'Contacta a tu administrador para saber más detalles',
      ],
    },
    component: MessageView,
  },
  {
    path: '/up-to-date',
    name: 'up-to-date',
    props: { messages: ['¡Felicitaciones!', 'Estás al día con tus pagos'] },
    component: MessageView,
  },
  {
    path: '/error',
    name: 'error',
    props: {
      messages: [
        'Ups, hubo un problema...',
        'Por favor intenta más tarde',
        'Contacta a tu administrador para saber más detalles',
      ],
    },
    component: MessageView,
  },
  {
    path: '/:pathMatch(.*)*',
    //props: { messages: ["404", "Página no encontrada"] },
    //component: MessageView,
    component: SearchVouchersView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
